import React, { FC } from 'react';

import { Text } from 'components/UI';

import styles from './watermark.module.scss';

interface IProps {
  title?: string;
}

const Watermark: FC<IProps> = ({
  title,
}) => (
  <Text
    noTag
    category="h4"
    className={styles.watermark}
  >
    {title || 'Coatue'}
  </Text>
);

export default Watermark;
